export default __webpack_public_path__ + "static/foto-3-af7db2f32f910baaa5fd716c80f7750a.jpg";